(function (window, document) {
  'use strict';

  var script = document.currentScript;
  var containerId = script && script.getAttribute('data-gtm-container-id');
  var requireConsent = script && script.getAttribute('data-require-consent') === 'true';
  var consentKey = 'peach_analytics_consent_v1';
  var validContainerId = /^GTM-[A-Z0-9]+$/i.test(containerId || '');
  var gtmLoaded = false;
  var settingsTrigger = null;

  window.dataLayer = window.dataLayer || [];

  function gtag() {
    window.dataLayer.push(arguments);
  }

  if (requireConsent) {
    gtag('consent', 'default', {
      ad_storage: 'denied',
      ad_user_data: 'denied',
      ad_personalization: 'denied',
      analytics_storage: 'denied'
    });
  }

  function readConsent() {
    try {
      var value = window.localStorage.getItem(consentKey);
      return value === 'granted' || value === 'denied' ? value : null;
    } catch (error) {
      return null;
    }
  }

  function saveConsent(value) {
    try {
      window.localStorage.setItem(consentKey, value);
    } catch (error) {
      // The choice still applies to this page when storage is unavailable.
    }
  }

  function loadGoogleTagManager() {
    if (!validContainerId || gtmLoaded)
      return;

    gtmLoaded = true;
    window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
    var gtmScript = document.createElement('script');
    gtmScript.async = true;
    gtmScript.src = 'https://www.googletagmanager.com/gtm.js?id=' + encodeURIComponent(containerId);
    document.head.appendChild(gtmScript);
  }

  function consentBanner() {
    return document.querySelector('.cookie-consent');
  }

  function showConsentBanner(trigger) {
    var banner = consentBanner();
    if (!banner)
      return;

    settingsTrigger = trigger || null;
    banner.hidden = false;
    var firstButton = banner.querySelector('[data-cookie-consent="granted"]');
    if (trigger && firstButton)
      firstButton.focus();
  }

  function hideConsentBanner() {
    var banner = consentBanner();
    if (banner)
      banner.hidden = true;
    if (settingsTrigger) {
      settingsTrigger.focus();
      settingsTrigger = null;
    }
  }

  function setConsent(value) {
    saveConsent(value);
    gtag('consent', 'update', {
      ad_storage: 'denied',
      ad_user_data: 'denied',
      ad_personalization: 'denied',
      analytics_storage: value
    });
    if (value === 'granted')
      loadGoogleTagManager();
    hideConsentBanner();
  }

  function cleanText(value, maxLength) {
    return String(value || '').replace(/\s+/g, ' ').trim().slice(0, maxLength || 100);
  }

  function placementFor(element) {
    if (element.closest('.intro')) return 'hero';
    if (element.closest('footer')) return 'footer';
    if (element.closest('.contact-menu')) return 'contact_menu';
    if (element.closest('.contact-methods')) return 'contact_card';
    if (element.closest('.actions')) return 'article';
    return 'content';
  }

  function track(eventName, parameters) {
    if (requireConsent && readConsent() !== 'granted')
      return;

    var eventParameters = {};
    Object.keys(parameters || {}).forEach(function (key) {
      var value = parameters[key];
      if (value !== undefined && value !== null && value !== '')
        eventParameters[key] = typeof value === 'string' ? cleanText(value) : value;
    });
    gtag('event', eventName, eventParameters);
  }

  function trackLink(link) {
    var href = link.getAttribute('href') || '';
    var placement = placementFor(link);

    if (/^\/boka-tid-priser\/?(?:\?|#|$)/.test(href)) {
      var person = '';
      try {
        person = new URL(href, window.location.origin).searchParams.get('person') || '';
      } catch (error) {}
      track('booking_cta_click', {
        source_page: window.location.pathname,
        cta_text: link.textContent,
        placement: placement,
        staff_filter: person
      });
      return;
    }

    if (/^mailto:/i.test(href)) {
      track('contact_click', { contact_method: 'email', placement: placement, source_page: window.location.pathname });
      return;
    }

    if (/instagram\.com/i.test(href)) {
      track('contact_click', { contact_method: 'instagram', placement: placement, source_page: window.location.pathname });
      return;
    }

    if (/facebook\.com/i.test(href)) {
      track('contact_click', { contact_method: 'facebook', placement: placement, source_page: window.location.pathname });
      return;
    }

    if (/goo\.gl\/maps|google\.[^/]+\/maps/i.test(href)) {
      var salon = window.location.pathname.indexOf('ostermalm') !== -1 ? 'ostermalm' :
        window.location.pathname.indexOf('vasastan') !== -1 ? 'vasastan' : 'salons';
      track('directions_click', { salon: salon, source_page: window.location.pathname });
    }
  }

  window.peachAnalytics = {
    track: track,
    getConsent: readConsent,
    showSettings: showConsentBanner
  };

  if (!requireConsent) {
    loadGoogleTagManager();
  } else if (readConsent() === 'granted') {
    gtag('consent', 'update', {
      ad_storage: 'denied',
      ad_user_data: 'denied',
      ad_personalization: 'denied',
      analytics_storage: 'granted'
    });
    loadGoogleTagManager();
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-cookie-consent]').forEach(function (button) {
      button.addEventListener('click', function () {
        setConsent(button.getAttribute('data-cookie-consent'));
      });
    });

    document.querySelectorAll('.cookie-settings-trigger').forEach(function (button) {
      button.addEventListener('click', function () { showConsentBanner(button); });
    });

    document.addEventListener('click', function (event) {
      var link = event.target.closest && event.target.closest('a[href]');
      if (link)
        trackLink(link);
    });

    if (requireConsent && !readConsent())
      showConsentBanner();
  });
})(window, document);
